const ABFieldConnectCore = require("../../core/dataFields/ABFieldConnectCore");
module.exports = class ABFieldConnect extends ABFieldConnectCore {};
